import { createFileRoute } from '@tanstack/react-router'
import { Walkdowns } from 'pages/walkdown/Walkdowns'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return null
  }

  return <Walkdowns siteId={siteId} />
}

export const Route = createFileRoute('/walkdowns/')({
  component: RouteComponent,
  staticData: {
    title: 'Walkdowns',
  },
})
